import $ from 'jquery';

const jsContainer = () => {
    var wrapper = $('.steps-list-block__image-wrapper');
    if (wrapper.length) {
        var bodyWidth = $('body').outerWidth()
        bodyWidth -= 190

        if (window.matchMedia('(min-width: 992px)').matches) {
            wrapper.css({
                width: `calc(${bodyWidth / 2}px`,
                marginLeft: `calc(${-bodyWidth / 2}px + 100%)`,
            })
        } else {
            wrapper.css({
                width: `100%`,
                marginLeft: 0,
            })
        }
    }
}

$(window).bind('resize', jsContainer).trigger('resize')

